import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { RoutingsService, UpdateRoutingInfoBody } from '../../Services/API';
import { MutationKeys, QueryKeys } from '../types';

export const useUpdateRouting = () => {
  const queryClient = useQueryClient();

  return useMutation(
    [MutationKeys.updateRouting],
    async (params: UpdateRoutingInfoBody) => {
      return RoutingsService.routingsControllerUpdateRouting({ body: params });
    },
    {
      onSuccess: () => {
        toast.success('Le routage a été mis à jour avec succès');
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchRoutings] });
      },
      onError: (error: AxiosError) => {
        if (error.response?.status === 403) {
          toast.error('Droits insuffisants pour mettre à jour des routages');
        } else if (error.response?.status === 422) {
          toast.error("Le siret n'a pas été trouvé");
        } else {
          toast.error('Une erreur est survenue lors de la mise à jour du routage');
        }
      },
    }
  );
};
